import styled from 'styled-components';

import { RowProps } from '.';

export const Wrapper = styled.div`
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray900};

  &:last-child {
    border-bottom-width: 0;
  }
`;

export const Title = styled.h2`
  padding-top: 10px;
  margin-right: 60px;
  color: ${({ theme }) => theme.colors.white100};
  font-size: ${({ theme }) => theme.fontSize.B1};
  font-weight: 700;
`;

export const Body = styled.div<Pick<RowProps, 'alignItems'>>`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'center'};
`;
